import { urls } from '../constants'
import api from './api'

const getCategoriesLaboratory = async ({ laboratoryId, page, limit }) => {
  try {
    const response = await api.get(urls.getCategoriesLaboratory, {
      params: {
        laboratoryId,
        page,
        limit
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const getFilterCategoriesLaboratory = async ({ text, laboratoryId, page, limit }) => {
  try {
    const response = await api.get(urls.getCategoriesLaboratory, {
      params: {
        text,
        laboratoryId,
        page,
        limit
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const addCategory = async ({ payload }) => {
  try {
    const response = await api.post(urls.addOrUpdateOrDeleteCategory, payload);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const updateCategory = async ({ _id, payload }) => {
  try {
    const response = await api.put(`${urls.addOrUpdateOrDeleteCategory}/${_id}`, payload);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const deleteCategory = async ({ categoryId }) => {
  try {
    const response = await api.delete(`${urls.addOrUpdateOrDeleteCategory}/${categoryId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
}

const categoriesServices = Object.freeze({
  addCategory,
  getCategoriesLaboratory,
  getFilterCategoriesLaboratory,
  deleteCategory,
  updateCategory
})

export default categoriesServices;